export { resolveTranslator } from './chunk-RRFUPILC.js';
import './chunk-4DPTK2CR.js';

// src/internal/util/password.ts
var PASSWORD_UPPERCASE = "ABCDEFGHJKMNPQRSTUVWXYZ";
var PASSWORD_LOWERCASE = "abcdefghjkmnpqrstuvwxyz";
var PASSWORD_NUMBERS = "23456789";
var PASSWORD_ALL = PASSWORD_UPPERCASE + PASSWORD_LOWERCASE + PASSWORD_NUMBERS;
var DEFAULT_PASSWORD_LENGTH = 16;
function generateSecurePassword(length = DEFAULT_PASSWORD_LENGTH) {
  if (length < 4) length = 4;
  const array = new Uint32Array(length);
  crypto.getRandomValues(array);
  const chars = [
    PASSWORD_UPPERCASE[array[0] % PASSWORD_UPPERCASE.length],
    PASSWORD_LOWERCASE[array[1] % PASSWORD_LOWERCASE.length],
    PASSWORD_NUMBERS[array[2] % PASSWORD_NUMBERS.length],
    ...Array.from(
      { length: length - 3 },
      (_, i) => PASSWORD_ALL[array[i + 3] % PASSWORD_ALL.length]
    )
  ];
  const shuffleArray = new Uint32Array(length);
  crypto.getRandomValues(shuffleArray);
  for (let i = chars.length - 1; i > 0; i--) {
    const j = shuffleArray[i] % (i + 1);
    [chars[i], chars[j]] = [chars[j], chars[i]];
  }
  return chars.join("");
}

// src/internal/util/validators.ts
function ean13CheckDigit(digits12) {
  if (!/^\d{12}$/.test(digits12)) return -1;
  let sum = 0;
  for (let i = 0; i < 12; i++) {
    sum += parseInt(digits12[i], 10) * (i % 2 === 0 ? 1 : 3);
  }
  return (10 - sum % 10) % 10;
}
function isEan13(value) {
  const s = value.trim();
  if (!/^\d{13}$/.test(s)) return false;
  return ean13CheckDigit(s.slice(0, 12)) === parseInt(s[12], 10);
}

export { DEFAULT_PASSWORD_LENGTH, generateSecurePassword, isEan13 };
//# sourceMappingURL=util.js.map
//# sourceMappingURL=util.js.map